<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1/GWuuYa/I6ifXeP8k8H8tequ5f2rdrvQ4=",
    "cpf": "U2FsdGVkX18CaN8luYBcNbYytXfaD8g1O/EvGHGO4vs="
  },
  {
    "num_cand": "U2FsdGVkX1/31RvC8ALWPSchqeOSq/+yMaxER+PYm6M=",
    "cpf": "U2FsdGVkX1+9sst/+eXX6A7i7dSNSFbc9pCs0zdIA3Q="
  },
  {
    "num_cand": "U2FsdGVkX1+lel+5Ex7RSIdnXGq7AmJGUdDO7DcJQV8=",
    "cpf": "U2FsdGVkX1+erWlgTzRCgdBRSf+MPVA13KEtYt83Yf0="
  },
  {
    "num_cand": "U2FsdGVkX19GvBgEV6uL3O7q4CbCyPtGcybEHGVCK3M=",
    "cpf": "U2FsdGVkX19qpF32Wk/PjNU7SrdFua22sq9EIDDLojU="
  },
  {
    "num_cand": "U2FsdGVkX19tC/5X1KjzZmt6gu7iybX4zGQZUx1A7LI=",
    "cpf": "U2FsdGVkX1+YPm7mc6FfaMRhuyyftBN/QCKJ++zUSsY="
  },
  {
    "num_cand": "U2FsdGVkX19dZZ6lYwxErTklhvC10kuLYTiXzB8ylgM=",
    "cpf": "U2FsdGVkX19LaVo3iUiodGPzwNTp4fywM8854hGmMBk="
  },
  {
    "num_cand": "U2FsdGVkX19O08vN5gqZQ+Lj90K3NpaL0zlUmwZGb70=",
    "cpf": "U2FsdGVkX1+CgA/Zj9NXkevvUCsI+QzbDe1hcxDeiac="
  },
  {
    "num_cand": "U2FsdGVkX1801v8Y6EDNpPaj5GYqZGIwZPYBSaj5EbM=",
    "cpf": "U2FsdGVkX1/fkMX3LoIDq88GRj2D6OZg3FW9KJ3+J7k="
  },
  {
    "num_cand": "U2FsdGVkX1+Ye0oIdp2nPAOIOsivrgJmVpW4NJDr1gQ=",
    "cpf": "U2FsdGVkX19dUsW+orul0RcJmedrkAcNQUAxbKWeBwE="
  },
  {
    "num_cand": "U2FsdGVkX18cPoND4kx2fLqe2kjnbYuiRVQA1fIKQEg=",
    "cpf": "U2FsdGVkX18HyoIQTFJUo+FFfzrcEoIxL2InzPkp06Y="
  },
  {
    "num_cand": "U2FsdGVkX19UwjKIjobe5n1/cQbmPfAT804pfOEX8Z4=",
    "cpf": "U2FsdGVkX18CxNwvmfPFnG4p+NfqZAtMdpNyZKzW7EA="
  },
  {
    "num_cand": "U2FsdGVkX1+m7CH+CQowjQNrJuINGKqiy1huNYTaZvw=",
    "cpf": "U2FsdGVkX19eI+bjbt/eJ8Ree7OWZ/OkhOshjAYgcvE="
  },
  {
    "num_cand": "U2FsdGVkX19qLzTNtwYp/e2wgwL7zFZpA/PpdwyXriU=",
    "cpf": "U2FsdGVkX19mkhbwQ3EIrIKDRH3I6QVmIBXDLcm6kmM="
  },
  {
    "num_cand": "U2FsdGVkX1+D2r4nbRzW7gG0qjs3u9Qv3yyVvgkymXg=",
    "cpf": "U2FsdGVkX1/6Mo7Azx6KiMCv+iFC7cgtxLRUkY002ec="
  },
  {
    "num_cand": "U2FsdGVkX18VC1C8rkzfhhvoSwoEV4KQ2i9c0YQVj+k=",
    "cpf": "U2FsdGVkX18TLLs9LR4v2WGpTA9SpDlkNHJYd4GhJ94="
  },
  {
    "num_cand": "U2FsdGVkX1/+1HQylzP3jjIg7s9HB+EDjcyl25Kaix0=",
    "cpf": "U2FsdGVkX1/O50w5qctH5keRp07xCfd8M1L8gWWlQ7Q="
  },
  {
    "num_cand": "U2FsdGVkX19Gt11YBpuQIpiPYrTgShUN/YZnvcYQewA=",
    "cpf": "U2FsdGVkX19OxIXmJ1nBQpLvS1z/1JnTPsn3vWGzJxw="
  },
  {
    "num_cand": "U2FsdGVkX1+NAOfpFtivsKjIm2MCn4N1B2LI+Frptjc=",
    "cpf": "U2FsdGVkX19qbEH0zhwOfqRjDN4yqQPDjRZyuPubnrU="
  },
  {
    "num_cand": "U2FsdGVkX1+WC0316CNRGXsyPQrqRpndzz5XFn6OMfg=",
    "cpf": "U2FsdGVkX1+EWeABqeUR46lT6wDGxMecX48uuFo24r0="
  },
  {
    "num_cand": "U2FsdGVkX19g0utHFH9I9fdKlHeV6n0gVbN0bsKQLA8=",
    "cpf": "U2FsdGVkX1+6OMFfW/wxSLM6Rp04fpf+7LFu7K1sI8A="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2204/2204_rec_inscr/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
